var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('new-hobbie-popup', {
    attrs: {
      "data-to-show": _vm.isNewHobbiePopupDisplayed,
      "hobbie-to-edit": _vm.hobbies[_vm.indexHobbieToEdit]
    },
    on: {
      "close": function ($event) {
        return _vm.changeStateNewHobbiePopup(false);
      },
      "addHobbie": function (newValue) {
        _vm.addNewHobbie(newValue);
      },
      "modifyHobbie": function (newValue) {
        _vm.modifyHobbie(newValue);
      }
    }
  }), _vm._v(" "), _c('change-picture-popup', {
    attrs: {
      "hobbie-to-edit": _vm.hobbies[_vm.indexHobbieToEdit],
      "data-to-show": _vm.isChoosePicPopupDisplayed
    },
    on: {
      "close": function ($event) {
        return _vm.changeStateChoosePicPopup(false);
      },
      "changePic": function (newValue) {
        _vm.changePic(newValue);
      },
      "removePic": function ($event) {
        return _vm.removePic(_vm.indexHobbieToEdit);
      }
    }
  }), _vm._v(" "), _c('change-icon-popup', {
    attrs: {
      "hobbie-to-edit": _vm.hobbies[_vm.indexHobbieToEdit],
      "data-to-show": _vm.isChooseIconPopupDisplayed
    },
    on: {
      "close": function ($event) {
        return _vm.changeStateChooseIconPopup(false);
      },
      "changeIcon": function (newValue) {
        _vm.changeIcon(newValue);
      },
      "removeIcon": function ($event) {
        return _vm.removeIcon(_vm.indexHobbieToEdit);
      }
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "my-15 mx-10"
  }, [_vm._v("Centres d'intérêt")]), _vm._v(" "), _vm.isErrorMaxLengthDisplayed ? _c('div', {
    staticClass: "text-pink-600 text-base text-center mb-8 mx-10"
  }, [_vm._v("\n    Vous ne pouvez pas sélectionner plus de 3 centres d'intérêt.\n  ")]) : _vm._e(), _vm._v(" "), _vm.isErrorMinLengthDisplayed ? _c('div', {
    staticClass: "text-pink-600 text-base text-center mb-8 mx-10"
  }, [_vm._v("\n    Afin d'avoir un rendu visuel optimal, il faut sélectionner exactement 3\n    centres d'intérêt.\n  ")]) : _vm._e(), _vm._v(" "), _vm.hobbies.length === 0 ? _c('div', [_c('h6', {
    staticClass: "mx-15 text-gray-600"
  }, [_vm._v("\n      Aucun centre d'intérêt n'a été renseigné sur votre Neopass.\n    ")]), _vm._v(" "), _c('h6', {
    staticClass: "mx-15 text-gray-600 mt-5"
  }, [_vm._v("\n      Pour mettre en avant vos centres d'intérêt, cliquer sur le bouton\n      \"ajouter des centres d'intérêt\"\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center mt-15"
  }, [_c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-indigo-600",
      "bg-color-square": "bg-indigo-600",
      "icon-color": "text-white",
      "libelle": "Ajouter des centres d'intérêt",
      "uppercase": true,
      "icon": "plus-circle",
      "type-shadow": "indigo-shadow"
    },
    on: {
      "clickAction": function ($event) {
        return _vm.changeStateNewHobbiePopup(true);
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center mt-10"
  }, [_c('illustration', {
    attrs: {
      "name": "evaluation"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _vm.hobbies.length > 0 || _vm.newHobbies.length > 0 ? _c('div', [!_vm.isWithPictures && _vm.hobbies.length > 0 ? _c('draggable', _vm._b({
    on: {
      "end": function ($event) {
        _vm.drag = false;
      },
      "start": function ($event) {
        _vm.drag = true;
      }
    },
    model: {
      value: _vm.form.data.hobbies,
      callback: function ($$v) {
        _vm.$set(_vm.form.data, "hobbies", $$v);
      },
      expression: "form.data.hobbies"
    }
  }, 'draggable', _vm.dragOptions, false), [_c('transition-group', {
    staticClass: "grid grid-cols-3 gap-3 mx-10",
    attrs: {
      "enter-active-class": "ease-in duration-1000",
      "enter-class": "bg-indigo-300 border-0 rounded-xl",
      "enter-to-class": "bg-none border-0 rounded-xl",
      "leave-active-class": "linear duration-1000",
      "leave-class": "h-20 opacity-100",
      "leave-to-class": "h-0 opacity-0",
      "tag": "div"
    }
  }, _vm._l(_vm.hobbies, function (hobbie, kh) {
    return _c('div', {
      key: 'hobbie' + kh,
      staticClass: "col-span-full md:col-span-1 flex justify-center md:justify-start"
    }, [_c('tag', {
      staticClass: "cursor-pointer",
      attrs: {
        "theme-color": hobbie.isDisplayed ? 'indigo-2' : 'white',
        "libelle": hobbie.value,
        "text-size": "text-sm",
        "text-font": "font-light",
        "icon": hobbie.isDisplayed ? 'minus-circle' : 'plus-circle',
        "icon-color": hobbie.isDisplayed ? 'text-indigo-600' : 'text-gray-600',
        "icon-size": "w-4 h-4",
        "can-truncate": true,
        "scale-on-hover": true
      },
      on: {
        "push": function ($event) {
          return _vm.displayHobbie(kh);
        }
      }
    })], 1);
  }), 0)], 1) : _vm._e(), _vm._v(" "), _vm.newHobbies && !_vm.isWithPictures ? _c('div', {
    staticClass: "grid grid-cols-3 gap-3 mt-5 mx-10"
  }, _vm._l(_vm.newHobbies, function (hobbie, kh) {
    return _c('div', {
      key: 'newhobbie' + kh,
      staticClass: "col-span-full md:col-span-1 flex md:space-x-1 items-center justify-center md:justify-start"
    }, [_c('CVNewValue', {
      attrs: {
        "old": hobbie,
        "right": false,
        "is-new": true
      },
      on: {
        "addNew": function (newValue) {
          _vm.importFromNeopass(hobbie);
        }
      }
    }), _vm._v(" "), _c('tag', {
      staticClass: "cursor-pointer",
      attrs: {
        "theme-color": 'white',
        "libelle": hobbie.value,
        "text-size": "text-sm",
        "text-font": "font-light",
        "icon": 'plus-circle',
        "icon-color": 'text-gray-600',
        "icon-size": "w-4 h-4",
        "can-truncate": true,
        "scale-on-hover": true
      }
    })], 1);
  }), 0) : _vm._e(), _vm._v(" "), _vm.isWithPictures ? _c('div', [_vm._l(_vm.hobbies, function (hobbie, kh) {
    return _c('div', {
      key: 'hobbie' + kh,
      staticClass: "col-span-full grid grid-cols-12 gap-x-4 py-5 odd:bg-gray-200 items-center odd:bg-opacity-50"
    }, [_c('div', {
      staticClass: "pl-5 md:pl-0 md:col-start-2 lg:col-start-3 col-span-8 md:col-span-7 flex space-x-1 items-center justify-between"
    }, [_c('div', {
      staticClass: "flex space-x-4 items-center"
    }, [_c('icon', {
      attrs: {
        "name": hobbie.icon
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-base font-normal"
    }, [_vm._v("\n              " + _vm._s(hobbie.value) + "\n            ")])], 1), _vm._v(" "), hobbie.image && hobbie.image != '' ? _c('img', {
      staticClass: "h-8 w-8 object-cover rounded-md",
      attrs: {
        "src": hobbie.image
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-span-4 lg:col-span-3 flex space-x-3 px-6 justify-end"
    }, [_c('radio-button', {
      attrs: {
        "name": 'hobbie' + kh + '_display',
        "value": ((((_vm.form || {}).data || {}).hobbies || [])[kh] || {}).isDisplayed || false
      },
      on: {
        "input": function (newValue) {
          _vm.displayHobbie(kh);
        },
        "loseFocus": function ($event) {
          return _vm.saveDatas();
        }
      }
    }), _vm._v(" "), !hobbie.fromNeopass || _vm.isWithPictures ? _c('div', {
      staticClass: "cursor-pointer px-2 relative",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.displayMenuMore(kh);
        }
      }
    }, [_c('icon', {
      staticClass: "text-pink-600",
      attrs: {
        "name": "more-vertical"
      }
    }), _vm._v(" "), _vm.menuMoreDisplayed === kh ? _c('div', {
      directives: [{
        name: "click-outside",
        rawName: "v-click-outside",
        value: _vm.hideMenuMore,
        expression: "hideMenuMore"
      }],
      staticClass: "absolute text-gray-600 bg-white px-5 py-4 rounded-xl shadow-lg flex flex-col space-y-2 text-sm -right-full z-10 w-max"
    }, [!hobbie.fromNeopass ? _c('p', {
      staticClass: "hover:text-gray-900 cursor-pointer",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.displayModifyHobbiePopup(kh);
        }
      }
    }, [_vm._v("\n                Modifier\n              ")]) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "hover:text-gray-900 cursor-pointer",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.displayChoosePicHobbiePopup(kh);
        }
      }
    }, [_vm._v("\n                Choisir une image\n              ")]), _vm._v(" "), _c('p', {
      staticClass: "hover:text-gray-900 cursor-pointer",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.displayChooseIconHobbiePopup(kh);
        }
      }
    }, [_vm._v("\n                Choisir une icône\n              ")]), _vm._v(" "), !hobbie.fromNeopass ? _c('p', {
      staticClass: "hover:text-gray-900 cursor-pointer",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.removeHobbie(kh);
        }
      }
    }, [_vm._v("\n                Supprimer\n              ")]) : _vm._e()]) : _vm._e()], 1) : _vm._e()], 1)]);
  }), _vm._v(" "), _vm._l(_vm.newHobbies, function (hobbie, kh) {
    return _c('div', {
      key: 'newhobbie' + kh,
      staticClass: "col-span-full grid grid-cols-12 gap-x-4 py-5 odd:bg-gray-200 items-center odd:bg-opacity-50"
    }, [_c('div', {
      staticClass: "col-span-2 flex items-center justify-center"
    }, [_c('CVNewValue', {
      attrs: {
        "old": hobbie,
        "right": false,
        "is-new": true
      },
      on: {
        "addNew": function (newValue) {
          _vm.importFromNeopass(hobbie);
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-span-7 flex space-x-1 items-center justify-between"
    }, [_c('div', {
      staticClass: "flex space-x-4 items-center"
    }, [_c('icon', {
      attrs: {
        "name": hobbie.icon
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-base font-normal"
    }, [_vm._v("\n              " + _vm._s(hobbie.value) + "\n            ")])], 1), _vm._v(" "), hobbie.image && hobbie.image != '' ? _c('img', {
      staticClass: "h-8 w-8 object-cover rounded-md",
      attrs: {
        "src": hobbie.image
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-span-3 flex space-x-3 px-6"
    })]);
  })], 2) : _vm._e(), _vm._v(" "), _c('add-button', {
    staticClass: "mt-10 mx-10",
    attrs: {
      "libelle": "Ajouter d'autres centres d'intérêt"
    },
    on: {
      "add": function ($event) {
        return _vm.changeStateNewHobbiePopup(true);
      }
    }
  })], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }